module.exports = __webpack_public_path__ + "img/singup.979be068.jpg";